import {getField, updateField} from 'vuex-map-fields';
import DEFINES from '@/defines';
import router from '@/router';
import * as API from '@/api';

// ==================== STATE =====================

function initialState () {
  return {
    details: null,
    uuid: null,
    error_message: null,
  };
}

const state = initialState ();

// ==================== ACTIONS =====================

const actions = {
  async login (context, payload) {
    var response = await API.availLink.login (payload);
    await context.dispatch ('afterLogin', {
      response: response,
    });
  },

  async afterLogin (context, payload) {
    /** If any user is accessing multiple avail links in different tabs of same browser, then
     *   1. Notify user about his previous session expiration.
     *   2. Reset the previous session and remaining state (due to confidential data).
     *   3. Set the session of fresh avail link (which is being access) and other details.
    */
    await context.dispatch ('alertUserAboutPreviousSession');
    await context.dispatch ('resetAll', {}, DEFINES.USE_ROOT);
    await context.dispatch ('setSession', payload.response);
    await context.dispatch ('setCompanyDetails', {
      companies: payload.response.companies,
    });
    await context.dispatch ('setOtherDetails', payload.response);

    router.push ({
      name: 'Dashboard',
      params: {
        company_id: context.rootGetters['company/getSelected'],
      },
    });
  },

  async alertUserAboutPreviousSession (context) {
    // User will get alert about previous session only if he is switching from normal mode to avail mode
    var is_logged_in = context.rootGetters['app/isLoggedIn'];
    var is_avail_session = context.rootGetters['app/isAvailsSession'];
    if (is_logged_in && !is_avail_session) {
      await context.dispatch (
        'app/showMessage',
        {
          message: 'Your previous session is expired',
          color: DEFINES.ERROR_COLOR,
        },
        DEFINES.USE_ROOT
      );
    }
  },

  setSession (context, payload) {
    context.commit (
      'auth/set_key',
      {
        key: payload.key,
      },
      DEFINES.USE_ROOT
    );

    context.commit (
      'auth/set_secret',
      {
        secret: payload.secret,
      },
      DEFINES.USE_ROOT
    );

    context.commit (
      'app/set_session_mode',
      {
        session_mode: payload.mode,
      },
      DEFINES.USE_ROOT
    );
  },

  setCompanyDetails (context, payload) {
    context.commit (
      'company/set_list',
      {
        companies: payload.companies,
      },
      DEFINES.USE_ROOT
    );

    var all_companies = context.rootGetters['company/getCompanies'];
    context.commit (
      'company/set_selected',
      {
        selected_company_id: all_companies[0]['id'],
      },
      DEFINES.USE_ROOT
    );
  },

  setOtherDetails (context, payload) {
    // Set avail link details
    context.commit ('set_details', {
      details: payload.details,
    });

    // Set avail link user profile
    context.commit (
      'user/set_profile',
      {
        profile: payload.user,
      },
      DEFINES.USE_ROOT
    );

    // If avail link having filters then set them to state
    if (payload.details.movie_filters) {
      context.commit (
        'filter/set_filters_from_link',
        {
          filters: payload.details.movie_filters,
        },
        DEFINES.USE_ROOT
      );
    }
  },

  async copySuccess (context) {
    context.dispatch (
      'app/showMessage',
      {
        message: 'Link copied successfully !',
        color: 'green',
      },
      DEFINES.USE_ROOT
    );
  },

  async copyFail (context) {
    context.dispatch (
      'app/showMessage',
      {
        message: 'Error while copying. Press Ctrl+c !',
        color: 'red',
      },
      DEFINES.USE_ROOT
    );
  },
};

// ==================== GETTERS =====================

const getters = {
  getField,
  get:state =>  {
    return state.details;
  },
  getUuid: state => {
    return state.details.id;
  },

  getErrorMesssage: state => {
    return state.error_message;
  },

  getUrl: state => payload => {
    return `${DEFINES.APP_URL}/company/${payload.company_id}/avail/link/${payload.uuid}`;
  }
};

// ==================== MUTATIONS =====================

const mutations = {
  updateField,
  reset (state) {
    // acquire initial state
    const s = initialState ();
    Object.keys (s).forEach (key => {
      state[key] = s[key];
    });
  },

  set_uuid (state, payload) {
    state.uuid = payload.uuid;
  },

  setErrorMessage (state, payload) {
    state.error_message = payload.message;
  },

  set_details (state, payload) {
    state.details = payload.details;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
